/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type SaasEnvironmentType = 'UNKNOWN' | 'PRODUCTION' | 'STAGING' | 'PRE_PRODUCTION' | 'NIGHTLY';

export const SaasEnvironmentType = {

    UNKNOWN: 'UNKNOWN' as SaasEnvironmentType,

    PRODUCTION: 'PRODUCTION' as SaasEnvironmentType,

    STAGING: 'STAGING' as SaasEnvironmentType,

    PRE_PRODUCTION: 'PRE_PRODUCTION' as SaasEnvironmentType,

    NIGHTLY: 'NIGHTLY' as SaasEnvironmentType
};

